import { ActionList, Button, Modal, Popover } from "@shopify/polaris";
import { CaretDownMinor } from "@shopify/polaris-icons";
import React, { useCallback, useReducer } from "react";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import { useMutation } from "@apollo/react-hooks";
import { UPDATE_AMAZON_IDEA_PRODUCT_STATUS } from "../../../graphql/mutations/amazon-idea";
import { useToastContext } from "../../shared/ToastContext";
import {
    AMAZON_IDEA_PRODUCT_STATUS,
    AMAZON_IDEA_PRODUCT_STATUS_BADGE,
} from "../../../variable";

const STATUS_BADGE = AMAZON_IDEA_PRODUCT_STATUS_BADGE;
const STATUS = AMAZON_IDEA_PRODUCT_STATUS;

export default function AmazonIdeaUpdateSingleProductStatus({
    status,
    setState: setStatus,
    ids,
}) {
    const [state, setState] = useReducer(reducerFn, {
        active: false,
        open: false,
        status: status,
    });

    const { setNotify, toggleToast } = useToastContext();

    const handleClick = useCallback(
        (active) => () => {
            setState({ active });
        },
        [],
    );

    const handleModelClick = useCallback(
        (open) => () => {
            setState({ open });
        },
        [],
    );

    const [updateProductStatus, { loading }] = useMutation(
        UPDATE_AMAZON_IDEA_PRODUCT_STATUS,
        {
            onCompleted: () => {
                setNotify({ msg: "Update Product Status success", err: false });
                handleModelClick(false)();
                handleClick(false)();
                setStatus({ status: state.status });
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
                handleModelClick(false)();
            },
        },
    );

    const handleAction = useCallback(
        (status) => () => {
            setState({ status, open: true });
        },
        [setState],
    );

    const activator = (
        <Button
            plain
            size="slim"
            icon={CaretDownMinor}
            onClick={handleClick(true)}
        />
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        updateProductStatus({
            variables: {
                ids,
                status: state.status,
            },
        });
    }, [updateProductStatus, ids, state.status]);

    return (
        <>
            <Popover
                activator={activator}
                active={state.active}
                onClose={handleClick(false)}
                fluidContent
                preferredAlignment="left"
            >
                <ActionList
                    items={[
                        {
                            content: STATUS_BADGE[STATUS.Active],
                            onAction: handleAction(STATUS.Active),
                        },
                        {
                            content: STATUS_BADGE[STATUS.Inactive],
                            onAction: handleAction(STATUS.Inactive),
                        },
                        {
                            content: STATUS_BADGE[STATUS.OutOfStock],
                            onAction: handleAction(STATUS.OutOfStock),
                        },
                        {
                            content: STATUS_BADGE[STATUS.Closed],
                            onAction: handleAction(STATUS.Closed),
                        },
                    ]}
                />
            </Popover>
            <Modal
                open={state.open}
                onClose={handleModelClick(false)}
                title="Update status"
                sectioned
                primaryAction={{
                    content: "Submit",
                    onAction: handleSubmit,
                    loading: loading,
                }}
                secondaryActions={[
                    { content: "Cancel", onAction: handleModelClick(false) },
                ]}
            >
                <p>
                    Are you sure to update product status to{" "}
                    {STATUS_BADGE[state.status] || ""}
                </p>
            </Modal>
        </>
    );
}
